// Marketing pages ported from the Lovable "violerts-launchpad" project (VWA-2898).
// Titles / descriptions come from each page's original <head> meta.
// /backend-search is intentionally absent: that URL is the app's real Backend Search tool
// (pages/backendSearch), which the Lovable "Backend search" placeholder page must not shadow.

import Home from './Home';
import About from './About';
import Alerts from './Alerts';
import Compliance from './Compliance';
import Contact from './Contact';
import EcbCodeSearch from './EcbCodeSearch';
import Faqs from './Faqs';
import Features from './Features';
import Glossary from './Glossary';
import HistoricalData from './HistoricalData';
import InfraCode from './InfraCode';
import Pricing from './Pricing';
import PropertyData from './PropertyData';
import Reports from './Reports';
import ViolationResolution from './ViolationResolution';

export const marketingPages = [
	{
		path: "/",
		component: Home,
		title: "Violerts | Property Compliance Monitoring in Real Time",
		description: "Violerts tracks every agency filing, violation and permit on your properties, sends real-time alerts, and helps you resolve issues before penalties stack up.",
	},
	{
		path: "/about",
		component: About,
		title: "About Us - Our Story, Team & Mission | Violerts",
		description: "Violerts was built by property operators tired of finding out about violations too late. Meet the team, our story, mission and the industries we serve.",
	},
	{
		path: "/alerts",
		component: Alerts,
		title: "Real-Time Violation Alerts | Violerts",
		description: "Get notified when Violerts detects new or updated records for a violation, complaint, permit or inspection — by email, SMS, Slack or webhook.",
	},
	{
		path: "/compliance",
		component: Compliance,
		title: "Compliance — Inspections, Local Laws & Portfolio Management | Violerts",
		description: "Stay ahead of inspections, local law deadlines and portfolio-wide compliance with Violerts.",
	},
	{
		path: "/contact",
		component: Contact,
		title: "Contact Violerts — Talk to Sales or Support",
		description: "Get in touch with the Violerts team about portfolio onboarding, pricing, API access or violation resolution support.",
	},
	{
		path: "/ecb-code-search",
		component: EcbCodeSearch,
		title: "ECB Code Search — Violation Reference | Violerts",
		description: "Search common ECB and OATH violation codes and understand the cited condition, issuing agency, and compliance category.",
	},
	{
		path: "/faqs",
		component: Faqs,
		title: "FAQs — Coverage, Alerts, Data & Pricing | Violerts",
		description: "Straight answers on agency coverage, alert speed, historical data, resolution support, exports and the free plan.",
	},
	{
		path: "/features",
		component: Features,
		title: "Features - Everything We Do | Violerts",
		description: "Real-time alerts, violation resolution, property reports, agency coverage, compliance tracking and decades of historical data — everything Violerts does for your portfolio.",
	},
	{
		path: "/glossary",
		component: Glossary,
		title: "NYC Property Compliance Glossary | Violerts",
		description: "Plain-language definitions for common NYC property compliance, agency, violation, and building record terms.",
	},
	{
		path: "/historical-data",
		component: HistoricalData,
		title: "Historical Property Data - Maps, Images, COs & More | Violerts",
		description: "Complete filing, complaint, inspection and penalty history per property — exportable for diligence, underwriting or litigation.",
	},
	{
		path: "/infra-code",
		component: InfraCode,
		title: "Infra Code & API Docs — Build on Violerts Data",
		description: "Ingestion pipelines, data dictionaries and REST endpoints documented so your engineers can build on top of Violerts.",
	},
	{
		path: "/pricing",
		component: Pricing,
		title: "Pricing — Plans for Every Portfolio | Violerts",
		description: "Simple per-property pricing for violation monitoring. Start free, scale to full portfolio coverage with API access and resolution support.",
	},
	{
		path: "/property-data",
		component: PropertyData,
		title: "Property Data — DOB, HPD, ECB/OATH & More | Violerts",
		description: "Violerts ingests and normalizes records from DOB, HPD, ECB/OATH, FDNY, DEP, DOT, DSNY, DOF, Landmarks, DOHMH and more.",
	},
	{
		path: "/reports",
		component: Reports,
		title: "Reports — Property Reports & Airtable Sync | Violerts",
		description: "Comprehensive Property Reports, Property Status Reports and Airtable integration for Violerts customers.",
	},
	{
		path: "/violation-resolution",
		component: ViolationResolution,
		title: "Violation Resolution | Violerts",
		description: "Don't just get alerted. Get it resolved. Violerts works with Building Violation Solutions to cure your violations — flag it, click Resolve, and follow it to certified correction.",
	},
];
